import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Loader2, Sparkles } from 'lucide-react';

export function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();
  const location = useLocation();

  // Show loading while checking auth state
  if (loading) {
    return (
      <div className="min-h-screen bg-[#FDFCF8] flex items-center justify-center">
        <div className="text-center">
          <Sparkles className="text-[#D4AF37] mx-auto mb-4" size={32} />
          <Loader2 className="animate-spin mx-auto text-[#D4AF37]" size={24} />
        </div>
      </div>
    );
  }

  // If not authenticated, redirect to home with return path
  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location, showAuth: true }} replace />;
  }

  return children;
}
